import { BaseService } from './base.service';
import { Observable, interval, timer } from 'rxjs';
import { Injectable } from '@angular/core';
import { switchMap, catchError, distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TimeService {
  workDateSource$ = new Observable<Date>();

  constructor(private httpClient: HttpClient,
    private baseService: BaseService) {
    const url = `${baseService.hostDomain}/api/server/workdate`;
    this.workDateSource$ = timer(0, 30000).pipe(
      switchMap(v => {
        return this.httpClient.get<Date>(url).pipe(
          catchError(err => {
            this.baseService.handleError(err, 'Sincronizando fechas con servidor.');
            return [];
          })
        );
      }),
      distinctUntilChanged()
    );
   }
}
